var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports", "vue", "vue-multiselect", "noty", "vee-validate", "vee-validate/dist/locale/de", "../Models/ContactPerson", "../Models/Tenant", "../Models/User", "../Models/Location", "../Models/Room", "../Models/Content/Content", "../Models/Content/Asset", "../Models/Configuration/PhysicalScreen", "../Models/Configuration/AV2Box", "../Components/ContactPersonComponent", "../Shared/KendoDataExtracter", "../EventEmitter", "../Models/Content/AssetEntry"], function (require, exports, vue_1, vue_multiselect_1, Noty, vee_validate_1, german, ContactPerson_1, Tenant_1, User_1, Location_1, Room_1, Content_1, Asset_1, PhysicalScreen_1, AV2Box_1, ContactPersonComponent_1, KendoDataExtracter_1, EventEmitter_1, AssetEntry_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var BasicViewControllerWithCRUDDataSource = (function (_super) {
        __extends(BasicViewControllerWithCRUDDataSource, _super);
        function BasicViewControllerWithCRUDDataSource(options_, vueInitiatorObjectOverrides) {
            if (vueInitiatorObjectOverrides === void 0) { vueInitiatorObjectOverrides = { data: {}, components: {}, directives: {}, computed: {}, methods: {}, watch: {} }; }
            var _this = _super.call(this) || this;
            _this.events = {
                roomsLoaded: "roomsLoaded",
                locationsLoaded: "locationsLoaded",
                tenantsLoaded: "tenantsLoaded",
                roomsLoadFailed: "roomsLoadFailed",
                locationsLoadFailed: "locationsLoadFailed",
                tenantsLoadFailed: "tenantsLoadFailed"
            };
            _this.locationsOptionsGetUrl = "/api/v1/locations";
            _this.roomsOptionsGetUrl = "/api/v1/rooms";
            _this.tenantsOptionsGetUrl = "/api/v1/tenants";
            if (options_.locationsOptionsGetUrl != undefined && options_.locationsOptionsGetUrl != "")
                _this.locationsOptionsGetUrl = options_.locationsOptionsGetUrl;
            if (options_.tenantsOptionsGetUrl != undefined && options_.tenantsOptionsGetUrl != "")
                _this.tenantsOptionsGetUrl = options_.tenantsOptionsGetUrl;
            if (options_.roomsOptionsGetUrl != undefined && options_.roomsOptionsGetUrl != "")
                _this.roomsOptionsGetUrl = options_.roomsOptionsGetUrl;
            _this.options = options_;
            var cp = new ContactPersonComponent_1.ContactPersonComponent();
            vue_1.default.use(vee_validate_1.default);
            vue_1.default.component('multiselect', vue_multiselect_1.default);
            _this.initVue(vueInitiatorObjectOverrides);
            _this.initRemoteDatasource();
            vue_1.default.use(vee_validate_1.default);
            try {
                _this.vueRoot.$validator.localize("de", {
                    messages: german.messages
                });
            }
            catch (e) {
                console.log("error @ BasicViewControllerWithCRUDDataSource: " + e);
            }
            return _this;
        }
        BasicViewControllerWithCRUDDataSource.prototype.initVue = function (vueInitiatorObjectOverrides) {
            var _this = this;
            this.vueRoot = new vue_1.default({
                el: this.options.htmlElementSelector,
                data: __assign({ model: this.GetNewInstanceOfType(this.options.type), showModal: false, options1: [], options2: [], locations: [], tenants: [], rooms: [], modal: {
                        message: ''
                    }, requestRunning: false }, vueInitiatorObjectOverrides.data),
                components: __assign({ 'modal': {
                        template: '#modal-template',
                    } }, vueInitiatorObjectOverrides.components),
                directives: __assign({ focus: {
                        inserted: function (el) {
                            el.focus();
                        }
                    } }, vueInitiatorObjectOverrides.directives),
                watch: __assign({}, vueInitiatorObjectOverrides.watch),
                computed: __assign({ accessibleByUser: {
                        get: function () {
                            return this.model.SecurityInfo.Level === 4;
                        },
                        set: function (newValue) {
                            if (newValue)
                                this.model.SecurityInfo.Level = 4;
                            else
                                this.model.SecurityInfo.Level = 8;
                        }
                    }, locationIdsArray: {
                        get: function () {
                            var array = window.Enumerable.from(this.locations).select(function (item) { return item.Id; }).toArray();
                            if (array.indexOf("all") == -1)
                                array.unshift("all");
                            return array;
                        }
                    } }, vueInitiatorObjectOverrides.computed),
                methods: __assign({ Update: function (event) {
                        if (_this.vueRoot.requestRunning)
                            return new Noty({
                                text: "Ein Befehl wird gerade verarbeitet. Bitte warten Sie bis zum Abschluss.",
                                killer: true,
                                type: 'info',
                                theme: 'metroui',
                                timeout: 2000
                            }).show();
                        if (_this.vueRoot.$validator !== undefined && _this.vueRoot.$validator.validateAll !== undefined) {
                            _this.vueRoot.$validator.validate('*').then(function () {
                                if (_this.vueRoot.errors.items.length > 0) {
                                    new Noty({
                                        text: "Speichern nicht möglich. Kontrollieren Sie bitte Ihre Eingaben.",
                                        type: 'error',
                                        theme: 'metroui',
                                        timeout: 6000
                                    }).show();
                                    return false;
                                }
                                else
                                    _this.vueRoot.PerformUpdate();
                            });
                        }
                        else {
                            _this.vueRoot.PerformUpdate();
                        }
                    }, PerformUpdate: function () {
                        if (_this.vueRoot.model.hasOwnProperty("Room") && _this.vueRoot.model.hasOwnProperty("RoomId"))
                            _this.vueRoot.model.RoomId = _this.vueRoot.model.Room.Id;
                        if (_this.vueRoot.model.hasOwnProperty("Location") && _this.vueRoot.model.hasOwnProperty("LocationId"))
                            _this.vueRoot.model.LocationId = _this.vueRoot.model.Location.Id;
                        KendoDataExtracter_1.KendoDataExtracter.SetKendoDatasourceEntryFromObject(_this.vueRoot.model, _this.remoteDataSource.at(0));
                        if (_this.options.IsInEditMode)
                            _this.remoteDataSource.at(0).dirty = true;
                        _this.remoteDataSource.sync();
                    }, DeleteItem: function () {
                        if (_this.vueRoot.requestRunning)
                            return new Noty({
                                text: "Ein Befehl wird gerade verarbeitet. Bitte warten Sie bis zum Abschluss.",
                                killer: true,
                                type: 'info',
                                theme: 'metroui',
                                timeout: 2000
                            }).show();
                        _this.remoteDataSource.remove(_this.remoteDataSource.at(0));
                        _this.remoteDataSource.sync()
                            .done(function () {
                            var n = new Noty({
                                text: "Klicken Sie hier um zur Übersicht zu gelangend. Sie werden in kürze automatisch weitergeleitet. ",
                                type: 'info',
                                theme: 'metroui',
                                timeout: 3000, callbacks: {
                                    onClose: function () {
                                        document.location.href = "./";
                                    }
                                }
                            }).show();
                        });
                    }, AddNewRecord: function (model, type) {
                        var obj = _this.GetVueModel(model);
                        obj.push(_this.GetNewInstanceOfType(type));
                    }, RemoveRecord: function (model, index) {
                        if (index < 0) {
                            console.log("BasicViewControllerWithCRUDDataSource -> initVue -> RemoveRecord: no item at the index " + index);
                            return;
                        }
                        var obj = _this.GetVueModel(model);
                        obj.splice(index, 1);
                    }, ShowConfirm: function () {
                        this.showModal = true;
                    }, CloseConfirm: function () {
                        this.showModal = false;
                    }, DsGetNewInstanceOfType: function (type) {
                        return _this.GetNewInstanceOfType(type);
                    }, GetData: function () {
                        this.options = window.optionslist;
                    }, GetLocationsOptionsAsync: function () {
                        jQuery.get(_this.locationsOptionsGetUrl).then(function (response) {
                            _this.vueRoot.locations = response;
                            _this.FireEvent(_this.events.locationsLoaded, response);
                        }, function (response) {
                            new Noty({
                                text: "Bereiche konnten leider nicht abgefragt werden",
                                type: 'error',
                                theme: 'metroui',
                                timeout: 6000
                            }).show();
                            _this.FireEvent(_this.events.locationsLoadFailed, response);
                        });
                    }, GetRoomsOptionsAsync: function () {
                        jQuery.get(_this.roomsOptionsGetUrl).then(function (response) {
                            _this.vueRoot.rooms = response;
                            _this.FireEvent(_this.events.roomsLoaded, response);
                        }, function (response) {
                            new Noty({
                                text: "Räume konnten leider nicht abgefragt werden",
                                type: 'error',
                                theme: 'metroui',
                                timeout: 6000
                            }).show();
                            _this.FireEvent(_this.events.roomsLoadFailed, response);
                        });
                    }, GetTenantsOptionsAsync: function () {
                        jQuery.get(_this.tenantsOptionsGetUrl).then(function (response) {
                            _this.vueRoot.tenants = response;
                            _this.FireEvent(_this.events.tenantsLoaded, response);
                        }, function (response) {
                            new Noty({
                                text: "Kunden konnten leider nicht abgefragt werden",
                                type: 'error',
                                theme: 'metroui',
                                timeout: 6000
                            }).show();
                            _this.FireEvent(_this.events.tenantsLoadFailed, response);
                        });
                    }, getLocationLabel: function (id) {
                        if (id == 'all')
                            return "Alle";
                        var result = window.Enumerable
                            .from(this.locations)
                            .select(function (item) {
                            return item;
                        })
                            .where(function (item) {
                            return id == item.Id;
                        }).toArray();
                        return result.length > 0 ? result[0].CompanyName : '';
                    } }, vueInitiatorObjectOverrides.methods)
            });
            $('select').on("change", function (e) {
                var fieldname = $(e.currentTarget).attr("data-id");
                if (_this.vueRoot.model.hasOwnProperty(fieldname))
                    _this.vueRoot.model[fieldname] = $(e.currentTarget).val();
            });
        };
        BasicViewControllerWithCRUDDataSource.prototype.GetNewInstanceOfType = function (type) {
            switch (type) {
                case "Array": return new Array();
                case "Tenant": return new Tenant_1.Tenant();
                case "User": return new User_1.User();
                case "Location": return new Location_1.Location();
                case "Room": return new Room_1.Room();
                case "ContactPerson": return new ContactPerson_1.ContactPerson();
                case "asset":
                case "Asset": return new Asset_1.Asset();
                case "Asset.Website":
                case "asset.website":
                    var website = new Asset_1.Asset();
                    website.AssetType = Content_1.AssetTypes.Website;
                    var we = new AssetEntry_1.WebsiteAssetEntry();
                    we.Purpose = "main";
                    website.Items.push(we);
                    return website;
                case "Asset.Stream":
                case "asset.stream":
                    var stream = new Asset_1.Asset();
                    stream.AssetType = Content_1.AssetTypes.Stream;
                    var se = new AssetEntry_1.StreamAssetEntry();
                    se.Purpose = "main";
                    stream.Items.push(se);
                    return stream;
                case "Asset.TvChannel":
                case "asset.tvchannel":
                    var tvchanel = new Asset_1.Asset();
                    tvchanel.AssetType = Content_1.AssetTypes.TVChannel;
                    var tve = new AssetEntry_1.TVChannelAssetEntry();
                    tve.Purpose = "main";
                    tvchanel.Items.push(tve);
                    return tvchanel;
                case "Website":
                case "website":
                    var weEntry = new AssetEntry_1.WebsiteAssetEntry();
                    weEntry.Purpose = "main";
                    return weEntry;
                case "Stream":
                case "stream":
                    var seEntry = new AssetEntry_1.StreamAssetEntry();
                    seEntry.Purpose = "main";
                    return seEntry;
                case "TvChannel":
                case "tvchannel":
                    var tvEntry = new AssetEntry_1.TVChannelAssetEntry();
                    tvEntry.Purpose = "main";
                    return tvEntry;
                case "Asset.FreeText":
                case "asset.freetext":
                    var freetext = new Asset_1.Asset();
                    freetext.AssetType = Content_1.AssetTypes.FreeText;
                    var fte = new AssetEntry_1.FreeTextAssetEntry();
                    fte.Purpose = "main";
                    freetext.Items.push(fte);
                    return freetext;
                case "FreeText":
                case "freetext":
                    var ftEntry = new AssetEntry_1.FreeTextAssetEntry();
                    ftEntry.Purpose = "main";
                    return ftEntry;
                case "Content": return new Content_1.Content();
                case "ContentTypes": return Content_1.ContentTypes;
                case "PhysicalScreen": return new PhysicalScreen_1.PhysicalScreen();
                case "AV2Box": return new AV2Box_1.AV2Box();
                default:
                    console.log("Could not create Instance of type: \"" + type + "\"");
                    return undefined;
            }
        };
        BasicViewControllerWithCRUDDataSource.prototype.GetVueModel = function (model) {
            var split = model.split(".");
            var obj = this.vueRoot[split[0]];
            for (var i = 0; i < split.length - 1; i++) {
                obj = obj[split[i + 1]];
            }
            return obj;
        };
        BasicViewControllerWithCRUDDataSource.prototype.initRemoteDatasource = function () {
            var _this = this;
            var base = this;
            this.remoteDataSource = new kendo.data.DataSource({
                transport: {
                    read: {
                        url: null,
                        type: "get", dataType: "json", contentType: "application/json"
                    },
                    create: {
                        url: null,
                        type: "post", dataType: "json", contentType: "application/json"
                    },
                    update: {
                        url: null,
                        type: "put", dataType: "json", contentType: "application/json"
                    },
                    destroy: {
                        url: null,
                        type: "delete", dataType: "json", contentType: "application/json"
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== "read" && data) {
                            return kendo.stringify(data);
                        }
                    }
                },
                schema: {
                    type: "json",
                    model: {
                        id: "Id",
                        fields: { Id: "Id" }
                    }
                },
                change: function (e) {
                    if (e.action != "remove" && e.items.length > 0)
                        base.vueRoot.model = KendoDataExtracter_1.KendoDataExtracter.GetPlainDataFromKendoDatasourceEntry(e.items[0]);
                    window.requestAnimationFrame(function () {
                        $('.select2-hidden-accessible').trigger("change");
                    });
                },
                requestStart: function (e) {
                    if (_this.vueRoot.hasOwnProperty("requestRunning"))
                        _this.vueRoot.requestRunning = true;
                },
                requestEnd: function (e) {
                    _this.DSReqestEndHandler(e);
                },
                error: function (e) {
                    _this.DSErrorHandler(e);
                }
            });
            (this.remoteDataSource.options.transport.create).url = this.options.createApiUrl;
            (this.remoteDataSource.options.transport.read).url = this.options.readApiUrl;
            (this.remoteDataSource.options.transport.update).url = this.options.updateApiUrl;
            (this.remoteDataSource.options.transport.destroy).url = this.options.destroyApiUrl;
            if (this.options.IsInEditMode)
                this.remoteDataSource.fetch(function () {
                    if (_this.remoteDataSource.at(0).hasOwnProperty("LocationId") || _this.remoteDataSource.at(0).hasOwnProperty("AssignedLocations") || _this.remoteDataSource.at(0).hasOwnProperty("AssignedLocation") || _this.remoteDataSource.at(0).hasOwnProperty("SecurityInfo"))
                        _this.vueRoot.GetLocationsOptionsAsync();
                    if (_this.remoteDataSource.at(0).hasOwnProperty("TetantId") || _this.remoteDataSource.at(0).hasOwnProperty("AssignedTetants") || _this.remoteDataSource.at(0).hasOwnProperty("AssignedTetant") || _this.remoteDataSource.at(0).hasOwnProperty("SecurityInfo"))
                        _this.vueRoot.GetTenantsOptionsAsync();
                    if (_this.remoteDataSource.at(0).hasOwnProperty("RoomId") || _this.remoteDataSource.at(0).hasOwnProperty("AssignedRooms") || _this.remoteDataSource.at(0).hasOwnProperty("AssignedRoom") || _this.remoteDataSource.at(0).hasOwnProperty("SecurityInfo"))
                        _this.vueRoot.GetRoomsOptionsAsync();
                });
            else {
                var newInstance = this.GetNewInstanceOfType(this.options.type);
                if (this.options.tenantId != undefined && newInstance.hasOwnProperty("TenantId"))
                    newInstance.TenantId = this.options.tenantId;
                this.remoteDataSource.add(newInstance);
                if (this.remoteDataSource.at(0).hasOwnProperty("LocationId") || this.remoteDataSource.at(0).hasOwnProperty("AssignedLocations") || this.remoteDataSource.at(0).hasOwnProperty("AssignedLocation") || this.remoteDataSource.at(0).hasOwnProperty("SecurityInfo"))
                    this.vueRoot.GetLocationsOptionsAsync();
                if (this.remoteDataSource.at(0).hasOwnProperty("TetantId") || this.remoteDataSource.at(0).hasOwnProperty("AssignedTetants") || this.remoteDataSource.at(0).hasOwnProperty("AssignedTetant") || this.remoteDataSource.at(0).hasOwnProperty("SecurityInfo"))
                    this.vueRoot.GetTenantsOptionsAsync();
                if (this.remoteDataSource.at(0).hasOwnProperty("RoomId") || this.remoteDataSource.at(0).hasOwnProperty("AssignedRooms") || this.remoteDataSource.at(0).hasOwnProperty("AssignedRoom") || this.remoteDataSource.at(0).hasOwnProperty("SecurityInfo"))
                    this.vueRoot.GetRoomsOptionsAsync();
            }
        };
        BasicViewControllerWithCRUDDataSource.prototype.GetJqParentEl = function () {
            return $(this.options.htmlElementSelector);
        };
        BasicViewControllerWithCRUDDataSource.prototype.DSReqestEndHandler = function (e) {
            var _this = this;
            if (this.vueRoot.hasOwnProperty("requestRunning") && e.type !== "create" && e.type !== "destroy")
                this.vueRoot.requestRunning = false;
            if (e.type === undefined || e.type == "read")
                return;
            if (e.type === "create" && document.location.href.toLowerCase().indexOf("/new") != -1)
                new Noty({
                    text: "Der Befehl wurde erfolgreich erstellt.",
                    type: 'success',
                    theme: 'metroui',
                    timeout: 600,
                    callbacks: {
                        afterClose: function () {
                            document.location.href = document.location.href.split("/new")[0] + "/" + _this.remoteDataSource.at(0).Id;
                        }
                    }
                }).show();
            else if (e.type === "update")
                new Noty({
                    text: "Der Datensatz wurde gespeichert.",
                    type: 'success',
                    theme: 'metroui',
                    timeout: 2000
                }).show();
            else if (e.type === "destroy")
                new Noty({
                    text: "Der Datensatz wurde gelöscht.",
                    type: 'success',
                    theme: 'metroui',
                    timeout: 600,
                    callbacks: {
                        afterClose: function () {
                            document.location.href = './';
                        }
                    }
                }).show();
            else if (e.response)
                new Noty({
                    text: "Der Befehl wurde erfolgreich ausgeführt.",
                    type: 'success',
                    theme: 'metroui',
                    timeout: 2000
                }).show();
            else
                new Noty({
                    text: "Der Befehl konnte nicht ausgeführt werden. Kontrollieren Sie bitte Ihre Eingaben und versuchen Sie es erneut.",
                    type: 'error',
                    theme: 'metroui',
                    timeout: 6000
                }).show();
        };
        BasicViewControllerWithCRUDDataSource.prototype.DSErrorHandler = function (e) {
            var description = "";
            try {
                for (var key in e.xhr.responseJSON) {
                    if (typeof (e.xhr.responseJSON[key]) != "string" && e.xhr.responseJSON[key]["length"] != undefined) {
                        description += key + ":<br/>";
                        for (var key2 in e.xhr.responseJSON[key]) {
                            description += "&nbsp;&nbsp;" + e.xhr.responseJSON[key][key2] + "<br/>";
                        }
                    }
                    else
                        description += key + ": " + e.xhr.responseJSON[key] + "<br/>";
                }
            }
            catch (e) {
                console.log("error @ DSErrorHandler:" + e);
            }
            new Noty({
                text: "Der Befehl konnte nicht ausgef\u00FChrt werden. \n                <br/>Fehler: <br/>" + (description != "" ? description : e.errorThrown) + "\n                <br/>xhr-status:" + e.xhr.status + "\n                <br/>xhr-statusText:" + e.xhr.statusText,
                type: 'error',
                theme: 'metroui',
                timeout: 6000
            }).show();
        };
        return BasicViewControllerWithCRUDDataSource;
    }(EventEmitter_1.EventEmitter));
    exports.BasicViewControllerWithCRUDDataSource = BasicViewControllerWithCRUDDataSource;
    (function (n) {
        if (window["Noty"] == undefined)
            window["Noty"] = Noty;
    })(Noty);
    $(function () {
        var optionsList = window["viewControllerData"];
        for (var i in optionsList) {
            window["viewController" + i] = new BasicViewControllerWithCRUDDataSource(optionsList[i]);
        }
    });
});
//# sourceMappingURL=BasicViewControllerWithCRUDDataSource.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/BasicViewControllerWithCRUDDataSource.js
// module id = 36
// module chunks = 0